import { render } from "./UserAgreePage.vue?vue&type=template&id=259dba00"
import script from "./UserAgreePage.vue?vue&type=script&lang=js"
export * from "./UserAgreePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__